import { TransactionCode } from '@services/appsync/types';
import React from 'react';
import { ActivityRecord } from '../types';
import { amountFmt, dateFmt } from '../util';
import { RecordView } from './RecordView';

type TransactionCardProps = {
  record: Extract<ActivityRecord, { type: 'Transaction' }>;
};

export const TransactionCard: React.FC<TransactionCardProps> = ({ record }) => {
  const { amount, code, posted_at, dividend_detail } = record.dataType;
  const { base_yield, rewards_applied, total_yield } = dividend_detail ?? {};
  const data: [label: string, value: string][] = [];
  const fundRate = (Number(base_yield ?? 0) * 100).toFixed(2) + '%';
  const yourRate = (Number(total_yield ?? 0) * 100).toFixed(2) + '%';

  const TITLE: Record<TransactionCode, string> & { NA: 'n/a' } = {
    DEPOSIT_CANCEL: 'Deposit Canceled',
    DEPOSIT_ESCROW: 'Deposit Pending',
    DIVIDEND: 'Dividend',
    DIVIDEND_REINVESTMENT: 'Dividend Reinvestment',
    FEE_BANK: 'Bank Fee',
    NA: 'n/a',
    PLAN_FEE: 'Plan Fee',
    REVOKE: 'Revoke',
    TRADE_AUTO_BUY: 'Auto Investment',
    TRADE_BUY: 'Investment',
    TRADE_SELL: 'Redemption',
    WITHDRAWAL: 'Withdrawal',
  };

  const title = TITLE[record.dataType.code ?? 'NA'];

  switch (code) {
    case 'DIVIDEND':
      data.push(['Date', dateFmt(posted_at ?? '')]);
      data.push(['Amount', base_yield ? amountFmt(base_yield ?? 0) : 'n/a']);
      data.push(['Bonus', rewards_applied ? amountFmt(rewards_applied ?? 0) : 'n/a']);
      data.push(['Total', total_yield ? amountFmt(total_yield ?? 0) : 'n/a']);
      data.push(['Your Annualized Payout Rate', yourRate]);
      data.push(['Fund Annualized Payout Rate', fundRate]);
      break;
    case 'FEE_BANK':
      data.push(['Date', dateFmt(posted_at ?? '')]);
      data.push(['Amount', amount ? amountFmt(amount ?? 0) : 'n/a']);
      data.push(['Type', title ?? 'n/a']);
      break;
    case 'PLAN_FEE':
      data.push(['Date', dateFmt(posted_at ?? '')]);
      data.push(['Amount', amount ? amountFmt(amount ?? 0) : 'n/a']);
      data.push(['Type', title ?? 'n/a']);
      break;
    default:
  }

  return (
    <RecordView
      dateLabel={dateFmt(posted_at ?? '')}
      activityName={title ?? 'n/a'}
      activityDesc=""
      amount={amountFmt(amount ?? 0)}
      status=""
      data={data}
      icon={code === TransactionCode.DIVIDEND ? 'bolt' : null}
    />
  );
};
